import { render, staticRenderFns } from "./MServPrizeComp.vue?vue&type=template&id=5f22d241&"
import script from "./MServPrizeComp.vue?vue&type=script&lang=js&"
export * from "./MServPrizeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports